module.exports = __webpack_public_path__ + "img/file-csv.77f55a09.svg";